import type { IntlShape } from 'react-intl';
import type { ToolUseItem } from '../../../../contracts/harness.types';

import {
  readRecordArray,
  readString,
  readToolResultData,
  readToolResultMetadata,
  readToolResultRecord,
} from '../../../../contracts/projects/harness/toolResult';

import type { ArtefactPayload } from './shared/artefact-tool';
import {
  renderStandardExportToolUse,
  type OpenExportDocumentPayload,
} from './shared/exportDocumentPreview';

import type { JSX } from 'react';

const readExportToPdfPayload = (item: ToolUseItem): ArtefactPayload => {
  const result = readToolResultRecord(item);
  const providerData = readToolResultData(item);
  const metadataExport = readRecordArray(
    readToolResultMetadata(item),
    'pdf_exports'
  )?.[0];
  const exportData = providerData ?? metadataExport ?? result;

  return {
    url: readString(exportData, 'download_url'),
    title:
      readString(exportData, 'title') ??
      readString(item.input, 'title') ??
      readString(exportData, 'filename'),
    filename: readString(exportData, 'filename'),
  };
};

export const renderExportToPdfToolUse = (
  item: ToolUseItem,
  intl: IntlShape,
  onOpenDocumentExport?: (payload: OpenExportDocumentPayload) => void
): JSX.Element | null => {
  const payload = readExportToPdfPayload(item);
  if (!payload.title && !payload.filename) return null;

  return renderStandardExportToolUse(
    item,
    intl,
    {
      artefactType: 'pdf',
      titleFallback: { id: 'pjArtPdf07', defaultMessage: 'PDF export' },
      readPayload: () => payload,
    },
    onOpenDocumentExport
  );
};
